import React, { Component } from 'react';

class WhoToUse extends Component {

  constructor(props) {
    super(props);
  }


  render() {

    return (
      <div>
        <strong>How Do These Documents Work?</strong><br/>
        DemDoc enables decentralized, democratic, "owner-less" document creation. When a person creates a document and sends its sharing link to their collaborators, everyone with the link becomes an equally-powerful co-author. Each co-author can add sentences or propose edits to sentences. Co-authors vote on edits. Majority determines whether an edit stays or goes. The original document creator has no privileges the co-authors do not. The document cannot be deleted; it lives so long as someone has a link to it.
        <br/>
      </div>
      )
  }
}
export default WhoToUse;
